module.exports = __webpack_public_path__ + "static/media/VAS_FEEDBACK_1.dba4aa7e.svg";